// angular
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// services
import { CommentsService } from '@app/core/shared/services/comments.service';
import { DialogService } from '@app/core/shared/services/dialog.service';
// components
import { ReportDialogComponent } from '@app/core/components/report-dialog/report-dialog.component';
// interfaces & env
import { ICommentData } from '@app/shared/interfaces/comment.interface';
import { environment } from '@environments/environment';
// pipes
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';
import { ImageSourcePipe } from '@app/shared/pipes/image-source.pipe';

@Component({
  selector: 'pwj-comment-box',
  standalone: true,
  imports: [
    CommonModule,
    NgOptimizedImage,
    TranslateModule,
    TranslateDataPipe,
    ImageSourcePipe,
  ],
  templateUrl: './comment-box.component.html',
  styleUrl: './comment-box.component.scss',
})
export class CommentBoxComponent {
  public baseUrl: string = environment.baseUrl.base;

  // inputs
  comment = input.required<ICommentData>();
  isReplay = input<boolean>();

  // dependencies
  private readonly _commentsService = inject(CommentsService);
  private readonly _dialogService = inject(DialogService);

  constructor() {}

  // on replay functionality
  public onReplay() {
    const commentReplay = {
      id: this.comment()._id,
      user: `${this.comment()?.user?.first_name} ${
        this.comment()?.user?.last_name
      }`,
    };
    // set comment replay
    this._commentsService.commentReplay.set(commentReplay);
  }

  public onReport() {
    const isMobileView = window.matchMedia('(max-width: 47.99em)').matches;

    this._dialogService.open(ReportDialogComponent, {
      width: isMobileView ? '100vw' : '29em',
      height: 'auto',
      panelClass: 'overlay-panel--report-dialog',
      data: {
        commentId: this.comment()._id,
      },
    });
  }
}
